import type {
  StoreDetailsFeatureFlagApiClientApplication,
  StoreDetailsFeatureFlagsApiResponse,
  StoreDetailsFeatureFlagClient,
  StoreDetailsFeatureFlagRow,
} from '../../../../types/features/storeDetails/featureFlags';

const CLIENT_TO_API_CLIENT: Record<StoreDetailsFeatureFlagClient, StoreDetailsFeatureFlagApiClientApplication> = {
  mobile_app: 'react_native',
  webapp: 'webapp',
};

const API_CLIENT_TO_CLIENT: Record<StoreDetailsFeatureFlagApiClientApplication, StoreDetailsFeatureFlagClient> = {
  react_native: 'mobile_app',
  webapp: 'webapp',
};

export const mapStoreDetailsFeatureFlagClientToApiClient = (
  client: StoreDetailsFeatureFlagClient,
): StoreDetailsFeatureFlagApiClientApplication => CLIENT_TO_API_CLIENT[client];

export const mapStoreDetailsFeatureFlagsResponseToRows = (
  response: StoreDetailsFeatureFlagsApiResponse,
): StoreDetailsFeatureFlagRow[] => {
  if (!Array.isArray(response.features)) {
    return [];
  }

  return response.features.map((item) => ({
    assignedToStore: Boolean(item.assigned),
    client: API_CLIENT_TO_CLIENT[item.feature_flag.client_application],
    displayName: item.feature_flag.display_name,
    effectiveEnabled: Boolean(item.effectively_enabled),
    featureKey: item.feature_flag.key,
    globalEnabled: item.feature_flag.global_enabled,
    id: item.feature_flag.id,
    reason: item.effective_reason,
    rolloutScope: item.feature_flag.rollout_scope,
    rolloutTarget: item.feature_flag.rollout_target,
  }));
};
